import ReducerUtils from "../../../utils/ReducerUtils"
import Actions      from "../../../model/constant/actions"


const savingNegativeKeywords = ReducerUtils.createReducer(false,{
  [Actions.SAVING_NEGATIVE_KEYWORDS] : (state,action)=>action.status,
})

export default savingNegativeKeywords